import { createGlobalStyle } from 'styled-components';

const CustomGlobalStyles = createGlobalStyle`
    html {
        font-family: CeraProRegular, sans-serif;
        scroll-behavior: smooth;
    }

    div[id^="open-appointments-"] h3,
    div[id^="open-appointments-"] h4,
    #root h3,
    #root h4 {
        margin: 0;
        box-sizing: border-box;
    }
`;

export { CustomGlobalStyles };
